import { Box, BoxProps, styled } from '@mui/material';
import { Header, Page, Toolbox } from 'redesign';
import { TodoSectionDataProvider } from './todo-list/todo-data-provider';
import { AnalyticsSectionDataProvider } from './analytics/analytics-data-provider';
import { ShiftOverviewChartDataProvider } from './shift-overview/shift-overview-chart-data-provider';

export const Dashboard = () => {
  return (
    <Page header={<Header titleText="Dashboard" />} toolbox={<Toolbox />}>
      <DashboardContainer>
        <AnalyticsSectionDataProvider />
        <TodoSectionDataProvider />
        <ShiftOverviewChartDataProvider />
      </DashboardContainer>
    </Page>
  );
};

const DashboardContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(4),
  width: '100%',
  height: 'fit-content',
}));
